/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'
import { of } from 'rxjs'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import times from 'lodash/times'

import { getProducts as getProductsService } from '@smartcoop/services/apis/smartcoopApi/resources/product'

import { productGroupService } from './productGroupService'

const PRODUCT_FIELDS = [
  'productId', 'active', 'commercialization', 'continuous', 'cultivate', 'digitalization', 'minReceiptDate',
  'nfe', 'productGroupId','purchasing','scheduled','shortDescription','slug','barcodes','ean',
  'extraAttributes','createdAt','updatedAt'
]

export function productService(database) {
  async function createOrUpdate(products = []) {
    await database.write(async () => {
      const promises = products.map((product) => async () => {
        const register = await database.get('product')
          .query(Q.where('productId', product?.productId || product?.id))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        if(product?.deletedAt) {
          return
        }
        await database.get('product').create((item) => {
          PRODUCT_FIELDS.forEach((field) => {
            if(
              field === 'extraAttributes' ||
              field === 'ean' ||
              field === 'barcodes' ||
              field === 'productGroup'
            ) {
              item[field] = JSON.stringify(product[field])
            }
            if(field === 'productId') {
              item[field] = product?.productId || product?.id
            } else {
              item[field] = product[field]
            }
          })
        })
      })

      await Promise.all(promises.map((fn) => fn()))
    })
  }

  async function deleteProductById(productId) {
    await database.write(async () => {
      const register = await database.get('product')
        .query(Q.where('productId', productId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('product').query().destroyAllPermanently()
    })
  }

  async function findProductById(productId) {
    return database
      .get('product')
      .query(Q.where('productId', productId))
      .fetchOne()
  }

  function observeProducts(productsLoading = false) {
    if(productsLoading) {
      return of([])
    }
    const productCollection = database.collections.get('product')

    return productCollection.query().observe()
  }

  async function syncProducts(params, onEnd = () => {}) {
    database.collections.get('product').query().fetch().then(async result => {

      let products = []
      const { data: { data: response, totalPages } } = await getProductsService(
        { ...params, active: true, limit: 500, updatedAt: isEmpty(result) || result?.length < 40 ? null : params?.updatedAt || null }
      )
      products = [...products, ...response]

      if (totalPages > 1) {
        const promises = times(totalPages, async (index) => {
          const { data: { data } } = await getProductsService(
            { ...params, page: index + 1, active: true, limit: 500, updatedAt: isEmpty(result) || result?.length < 40 ? null : params?.updatedAt || null }
          )
          products = [...products, ...data]
        })

        await Promise.all(promises)
      }

      await createOrUpdate(products)
      productGroupService(database).syncProductGroups({ updatedAt: isEmpty(result) || result?.length < 40 ? null : params?.updatedAt || null })
      onEnd()
    })
  }

  return {
    createOrUpdate,
    clearTable,
    deleteProductById,
    findProductById,
    observeProducts,
    syncProducts
  }
}